import {
  FaBuilding,
  FaRegFileAlt,
  FaLeaf,
  FaLandmark,
  FaAnchor,
} from 'react-icons/fa';

export const BRAND_GOLD = '#eeb95d';

export const HERO_VIDEO_ID = 'mpuasMTSbTU';

export const PERMIT_ITEMS = [
  {
    icon: FaRegFileAlt,
    text: 'Land Ownership',
    subtext: 'Land Registry Certified',
    accent: 'gold',
  },
  {
    icon: FaLandmark,
    text: 'DGODT Approval',
    subtext: 'Zoning & Land Use',
    accent: 'teal',
  },
  {
    icon: FaLeaf,
    text: 'Environmental',
    subtext: 'Impact Assessment',
    accent: 'gold',
  },
  {
    icon: FaBuilding,
    text: 'Municipal',
    subtext: 'Samaná Council',
    accent: 'teal',
  },
  {
    icon: FaAnchor,
    text: 'Dominican Navy',
    subtext: 'Maritime Approval',
    accent: 'gold',
  },
];

export const PERMITS_IMAGE =
  'https://images.pexels.com/photos/29763051/pexels-photo-29763051/free-photo-of-business-meeting-with-documents-in-bergamo.jpeg';

export const CONTACT_PHONE = {
  display: '+1 (829) 423-2020',
  href: 'tel:+18294232020',
};
